export default __webpack_public_path__ + "static/media/Bengali_general_f.a3a2f5a5.wav";